module.exports = __webpack_public_path__ + "img/logo-light.1dc80cf0.png";